document.addEventListener('DOMContentLoaded', function() {
    var cookies = document.querySelector('.cb-content');
    if (!cookies) {
        return;
    }

    var close = document.querySelector('.cb_close');
    close.addEventListener('click', function(event) {
        var date = new Date();
        date.setTime(date.getTime() + (31 * 24 * 60 * 60 * 1000));
        var expires = "expires=" + date.toUTCString();
        document.cookie = "liveramp-cookies-bar=true; " + expires + "; path=/";

        cookies.classList.add('hide');
    });
});
